<!--代办处补货数量-->
<template>
  <div class="AgentReplenishmentQuantity app-container">
    <app-breadcrumb />
    <div class="page-container">
      <el-form size="small" :inline="true" :model="listQuery" label-position="right">
        <!-- 商品编号-->
        <el-form-item :label="$t('pmProductList.productId') + ':'">
          <el-input v-model.trim="listQuery.goodscode" clearable />
        </el-form-item>
        <el-button :loading="doLoading" type="primary" icon="el-icon-search" size="small" @click="handleFilter">
          {{ this.$t('operation.button.search') }}
        </el-button>
      </el-form>
      <el-table v-loading="doLoading" :data="list" border fit size="mini" stripe style="width: 100%">
        <!-- 商品名称 -->
        <el-table-column :label="$t('BiGoods.name')" prop="name" align="center" />
        <!-- 商品编码 -->
        <el-table-column :label="$t('BiGoods.goodsCode')" prop="goodscode" align="center" />
        <!-- 欠货数量 -->
        <el-table-column :label="$t('pd.goodsNum.owe')" prop="oweqty" align="center" />
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
        @pagination="getList" />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"
import { agentWareStocks } from "@/api/agent"
import { mapGetters } from "vuex";

export default {
  name: 'AgentReplenishmentQuantity',
  directives: {},
  components: { Pagination },
  data() {
    return {
      doLoading: false,
      list: [],
      total: 0,
      listQuery: {
        goodscode: '',
        page: 1,
        limit: 10
      }
    }
  },
  computed: {
    ...mapGetters([
      'userCode',
      'companyCode',
      'isAgent'
    ]),
  },
  mounted() {
    this.getList()
  },
  methods: {
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    getList() {
      this.doLoading = true
      this.list = []
      agentWareStocks({ ...this.listQuery }).then(res => {

        let excludeGoodsList = [
          'PAC01',
          'PAC02',
          'PK01224',
          'PK01324',
          'PK01424',
          'FVT-F012',
          'PK02724',
          'PK02824',
          'AF-N000005-24',
          'AF-N000006-24',
          'AF-N000007-24',
          'AF-N000004-24',
          'AF-N000009-24',
          'AF-N000008-24',
          'AF-N000010-25',
          'AF-N000011-25',
          'AF-N000008-24',
          'AF-N000012-25',
          'AF-N000013-25',
          'AF-N000014-26',
          'AF-N000015-26',
          'AF-N000016-26'
        ]
        res.data.records.forEach(v => {
          if (!excludeGoodsList.includes(v.goodscode)) {
            this.list.push(v)
          }
        })
        // this.list = res.data.records
        this.total = +res.data.total || 0
        this.doLoading = false
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.warn(err)
        this.doLoading = false
      })
    }
  }
}

</script>

<style scoped></style>
